import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_ops-framework/artifacts/p53i8p5i_ChatGPT%20Image%20May%205%2C%202026%2C%2007_55_14%20PM.png";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/what-we-do", label: "What We Do" },
  { to: "/who-its-for", label: "Who It's For" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header
      className="fixed top-0 inset-x-0 z-50 bg-white/95 backdrop-blur-md border-b border-[#E2E8F0]"
      data-testid="site-header"
    >
      <div className="h-20 px-6 lg:px-12 flex items-center justify-between max-w-[1440px] mx-auto">
        <Link
          to="/"
          className="flex items-center"
          data-testid="logo-link"
          onClick={() => setOpen(false)}
        >
          <img
            src={LOGO}
            alt="Backbench"
            className="h-16 lg:h-[72px] w-auto object-contain"
            data-testid="header-logo"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-1" data-testid="desktop-nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`nav-${item.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}-link`}
              className={({ isActive }) =>
                [
                  "relative px-4 py-2 text-sm font-semibold tracking-tight transition-colors duration-200 group",
                  isActive
                    ? "text-[#0A192F]"
                    : "text-[#475569] hover:text-[#0A192F]",
                ].join(" ")
              }
            >
              {({ isActive }) => (
                <>
                  {item.label}
                  <span
                    className={`absolute left-4 right-4 -bottom-0.5 h-0.5 bg-[#F68712] transition-transform duration-300 origin-left ${
                      isActive ? "scale-x-100" : "scale-x-0 group-hover:scale-x-100"
                    }`}
                  />
                </>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate("/contact")}
            className="relative hidden lg:inline-flex items-center bg-[#F68712] hover:bg-[#D87410] text-white font-bold tracking-wide px-6 py-3 transition-colors duration-200"
            data-testid="header-cta-book-call"
          >
            <span className="relative z-10">Book a Free Call</span>
            <span className="absolute inset-0 bg-[#F68712] animate-bb-pulse-ring pointer-events-none" />
          </button>
          <button
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden p-2 text-[#0A192F]"
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#E2E8F0] bg-white" data-testid="mobile-nav">
          <div className="px-6 py-4 flex flex-col">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${item.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}-link`}
                className={({ isActive }) =>
                  [
                    "py-3 text-base font-semibold border-b border-[#E2E8F0] last:border-b-0",
                    isActive ? "text-[#0A192F]" : "text-[#475569]",
                  ].join(" ")
                }
              >
                {item.label}
              </NavLink>
            ))}
            <button
              onClick={() => {
                setOpen(false);
                navigate("/contact");
              }}
              className="mt-4 inline-flex items-center justify-center bg-[#F68712] hover:bg-[#D87410] text-white font-bold tracking-wide px-6 py-3 transition-colors duration-200"
              data-testid="mobile-cta-book-call"
            >
              Book a Free Call
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
